// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const DropZone = require('client-v2/common/components/drop-zone')
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const CollectionEditModalImagePreview = require('./image-preview')

const bem = BemEntity('CollectionEditModalHeaderImagePreview')

function CollectionEditModalHeaderImagePreview({
  // Values
  className,
  name,
  pending,
  value,
  // Callbacks
  onClick,
  onDrop
}) {
  // Hooks
  const [ isDragging, setDragging ] = React.useState(false)
  const onImageClick = React.useCallback(
    () => {
      if (onClick) {
        onClick({ name })
      }
    },
    [ onClick, name ]
  )
  const onDrag = React.useCallback(
    dragging => {
      setDragging(dragging)
    },
    [ setDragging ]
  )
  const onImageDrop = React.useCallback(
    file => {
      if (onDrop) {
        onDrop({ name, file })
      }
    },
    [ onDrop, name ]
  )
  // Render
  return (
    tag(DropZone, {
      className: classNames(
        className,
        bem.block({
          default: !value,
          dragging: isDragging,
          pending
        })
      ),
      disabled: pending,
      onActive: onDrag,
      onClick: onImageClick,
      onDrop: onImageDrop
    },
      tag(CollectionEditModalImagePreview, {
        className: bem.element('preview'),
        value: value,
        onClick: onImageClick,
        label: 'Edit Collection Banner Image'
      })
    )
  )
}

module.exports = CollectionEditModalHeaderImagePreview
